export default __webpack_public_path__ + "static/media/Maduro3-Open.825a47bd.jpg";